import React from 'react';
import { AIBrainIcon } from './Icons';
import './AIProcessingLoader.css';

interface AIProcessingLoaderProps {
  stage: 'uploading' | 'converting' | 'completing';
  progress?: number;
}

const AIProcessingLoader: React.FC<AIProcessingLoaderProps> = ({ stage, progress = 0 }) => {
  const getStageInfo = () => {
    switch (stage) {
      case 'uploading':
        return {
          title: '正在上传照片',
          description: '正在将您的照片上传到AI服务器...'
        };
      case 'converting':
        return {
          title: '正在施展魔法',
          description: '人工智能正在为您的照片进行风格化转换...'
        };
      case 'completing':
        return {
          title: '搞定',
          description: '正在为您呈现转换结果...'
        };
      default:
        return {
          title: '处理中',
          description: '请稍候...'
        };
    }
  };

  const stageInfo = getStageInfo();

  return (
    <div className="ai-processing-loader">
      <div className="ai-processing-overlay">
        <div className="ai-processing-content">
          {/* AI核心动画 */}
          <div className="ai-core-animation">
            <div className="ai-core">
              <div className="ai-core-inner">
                <div className="ai-brain">
                  <AIBrainIcon width="90" height="80" />
                </div>
              </div>
              
              {/* 脉冲环 */}
              <div className="ai-pulse-ring ring-1"></div>
              <div className="ai-pulse-ring ring-2"></div>
              <div className="ai-pulse-ring ring-3"></div>
            </div>
            
            {/* 数据流动画 */}
            <div className="ai-data-stream">
              <div className="data-particle particle-1"></div>
              <div className="data-particle particle-2"></div>
              <div className="data-particle particle-3"></div>
              <div className="data-particle particle-4"></div>
              <div className="data-particle particle-5"></div>
              <div className="data-particle particle-6"></div>
            </div>
          </div>
          
          {/* 状态信息 */}
          <div className="ai-status-info">
            <h3 className="ai-stage-title">{stageInfo.title}</h3>
            
            {/* 进度条 */}
            {progress > 0 && (
              <div className="ai-progress-container">
                <div className="ai-progress-bar">
                  <div 
                    className="ai-progress-fill"
                    style={{ width: `${Math.min(progress, 100)}%` }}
                  ></div>
                </div>
              </div>
            )}
          </div>
          
          {/* 技术感装饰 */}
          <div className="ai-tech-decorations">
            <div className="tech-line tech-line-1"></div>
            <div className="tech-line tech-line-2"></div>
            <div className="tech-line tech-line-3"></div>
            <div className="tech-line tech-line-4"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AIProcessingLoader;
